// 커플링 설정 참가자 탭의 종류별 편집기 — features 쪽 선언이 UI 등록부에 등록한다(레지스트리는 UI 를 모른다, P5)
import { registerParticipantUi } from '@/app/participants/participantUi';

registerParticipantUi('mars', { couplingParticipantEditor: () => import('./MarsCouplingParticipantEditor') });
registerParticipantUi('fmu', { couplingParticipantEditor: () => import('./FmuCouplingParticipantEditor') });
